import { configureStore, ThunkAction, Action, getDefaultMiddleware  } from '@reduxjs/toolkit'
import reducers from './slice'
export const store = configureStore({
    reducer: reducers,
    middleware: getDefaultMiddleware({
      serializableCheck: false,
    }),
})
  
  //  Define  types
export type AppDispatch = typeof store.dispatch
export type RootState = ReturnType<typeof store.getState>

export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action<string>
>